var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LazyEmitter } from './RenderThread';
import { ConsultScene, ConsultCookieName, ConsultQueryName, ConsultFromValues, SocketChannel } from '../const';
import { getConsultCookie, decodeURIComponentSafe } from '../utils';
/**
 * 智能咨询B端配置抽象类
 * 针对所有配置，提取细粒度的方法；
 */
var ConsultModel = /** @class */ (function (_super) {
    __extends(ConsultModel, _super);
    function ConsultModel(consult, citoken) {
        var _this = _super.call(this) || this;
        _this.isHalfConsult = function () {
            var from = _this.getQueryParams(ConsultQueryName.From);
            return from === ConsultFromValues.xj_Half;
        };
        // 是否全屏并且是搜索咨询页
        _this.isFullSearch = function () { return !_this.isHalfConsult() && _this.isSearchConsult(); };
        _this.consult = consult;
        _this.citoken = citoken;
        _this.guestID = _this.getGuestIDFromCookie();
        _this.gdtUID = getConsultCookie(ConsultCookieName.GDT_UID);
        _this.clickID = _this.getQueryParams(ConsultQueryName.Click_ID);
        _this.traceID = _this.getQueryParams(ConsultQueryName.Trace_ID) || _this.getQueryParams(ConsultQueryName.Trace_ID_V2);
        _this.uid = consult.u_id;
        _this.landingUrl = _this.getLandingUrl();
        return _this;
    }
    ConsultModel.prototype.updateConsult = function (consult) {
        this.consult = consult;
        this.onUpdate();
    };
    ConsultModel.prototype.updateCitoken = function (citoken) {
        this.citoken = citoken;
    };
    ConsultModel.prototype.getConsultConfig = function () {
        return this.consult.consult_config || {};
    };
    // 是否搜索咨询页
    ConsultModel.prototype.isSearchConsult = function () {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var consult_scene = this.consult.consult_config.consult_scene;
        return consult_scene === ConsultScene.Search;
    };
    // 是否是信息流
    ConsultModel.prototype.isFeedConsult = function () {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var consult_scene = this.consult.consult_config.consult_scene;
        return consult_scene === ConsultScene.Feed;
    };
    // 欢迎语是否有效
    ConsultModel.prototype.isValidGreeting = function () {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var _a = this.getConsultConfig(), greeting_enable = _a.greeting_enable, online_greeting = _a.online_greeting;
        // 欢迎语不为undefined, null, 或空字符串
        var checkGreeting = online_greeting;
        if (typeof online_greeting === 'string') {
            checkGreeting = checkGreeting.trim();
        }
        return greeting_enable === 1 && !!checkGreeting;
    };
    ConsultModel.prototype.getContactTimingType = function () {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var contact_timing_type = this.getConsultConfig().contact_timing_type;
        return contact_timing_type || 1;
    };
    ConsultModel.prototype.getChannel = function () {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var is_robot_start = this.getConsultConfig().is_robot_start;
        return is_robot_start ? SocketChannel.Robot : SocketChannel.Im;
    };
    ConsultModel.prototype.onUpdate = function () {
        this.emitRenderEvent('onUpdate');
    };
    /**
     * 获取咨询页url参数
     */
    ConsultModel.prototype.getQueryParams = function (params) {
        var query = new URLSearchParams(window.location.search);
        return query.get(params) || '';
    };
    ConsultModel.prototype.getGuestIDFromCookie = function () {
        return getConsultCookie(ConsultCookieName.Guest_Id) || getConsultCookie(ConsultCookieName.Guest_Id_Legacy);
    };
    // 执行parent.postmessage,并兼容
    ConsultModel.prototype.transferMessage = function (message, compatiblefun) {
        if (window.parent !== window) {
            // 嵌在iframe中
            window.parent.postMessage(message, '*');
        }
        else {
            compatiblefun === null || compatiblefun === void 0 ? void 0 : compatiblefun();
        }
    };
    ConsultModel.prototype.getLandingUrl = function () {
        return decodeURIComponentSafe(this.getQueryParams(ConsultQueryName.Landing_Url))
            || document.referrer;
    };
    return ConsultModel;
}(LazyEmitter));
export { ConsultModel };
